"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[465],{

/***/ 3465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_OptionsTab; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(1953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tab/Tab.js + 1 modules
var Tab = __webpack_require__(8661);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tabs/Tabs.js + 7 modules
var Tabs = __webpack_require__(9545);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tabs/tabsClasses.js
var tabsClasses = __webpack_require__(6748);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./data/mock-data.tsx



var locationsTab = [
    {
        id: "TAB_5635",
        label: "Tropical",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/FaUmbrellaBeach.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_4104",
        label: "CountrySide",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/GiMountainCave.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_8225",
        label: "OMG!",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/GiSpaceNeedle.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_5348",
        label: "Cabins",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/MdCabin.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_8534",
        label: "Arctic",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/BsSnow.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_8528",
        label: "Design",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/MdOutlineApartment.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_8542",
        label: "Shared Homes",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/MdHouseSiding.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_8522",
        label: "LakeFront",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/MdOutlineWater.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_8102",
        label: "National Parks",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/GiKidSlide.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_8538",
        label: "Bed & Breakfast ",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/AiOutlineCoffee.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_634",
        label: "Camping",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/FaCampground.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_8148",
        label: "A-frames",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/GiCampingTent.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_8173",
        label: "Domes",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/GiLightningDome.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_8186",
        label: "Tiny Homes",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/BiHomeAlt.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_8188",
        label: "Treehouses",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/GiEvilTree.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_8526",
        label: "Surfing",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/GiWaveSurfer.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_670",
        label: "Caves",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/GiCaveEntrance.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_8525",
        label: "Golfing",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/GiGolfFlag.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_8174",
        label: "Earth Homes",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/RiEarthquakeFill.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    },
    {
        id: "TAB_677",
        label: "Amazing Pools",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/icons/FaSwimmingPool.svg",
            width: "24",
            height: "24",
            loading: "lazy"
        })
    }, 
];

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/OptionsTab.tsx








var OptionsTab = function() {
    var ref = (0,react.useState)(0), value = ref[0], setValue = ref[1];
    var router = (0,next_router.useRouter)();
    var handleChange = function(event, newValue) {
        event.preventDefault();
        setValue(newValue);
        var query = router.query;
        query["category"] = newValue.toString();
        query["destination_id"] = newValue.toString();
        router.push({
            pathname: "/search",
            query: query
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                display: "flex",
                width: "100%",
                flexGrow: 1,
                px: {
                    xs: 0,
                    md: 2
                },
                alignItems: "center",
                mb: 3
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
                value: value,
                onChange: handleChange,
                variant: "scrollable",
                scrollButtons: true,
                sx: (0,_define_property/* default */.Z)({}, "& .".concat(tabsClasses/* default.scrollButtons */.Z.scrollButtons), {
                    "&.Mui-disabled": {
                        opacity: 0.3
                    }
                }),
                children: locationsTab.map(function(tab) {
                    return(// <Link href={`search?category=${tab.id}`} passHref>
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                        sx: {
                            color: "black",
                            opacity: 0.8,
                            fontSize: 13
                        },
                        icon: tab.icon,
                        label: tab.label,
                        value: tab.id
                    }, tab.id));
                })
            })
        })
    });
};
/* harmony default export */ var components_OptionsTab = (OptionsTab);


/***/ })

}]);